import { Label } from "@/components/ui/label";
import type { FieldRendererProps } from "./index";

export function SliderField({ label, required, properties, disabled }: FieldRendererProps) {
  const min = properties.min ?? 0;
  const max = properties.max ?? 100;
  const step = properties.step ?? 1;
  const defaultVal = properties.defaultValue ? Number(properties.defaultValue) : min;

  return (
    <div className="space-y-2">
      <Label>
        {label}
        {required && <span className="ml-1 text-destructive">*</span>}
      </Label>
      <div className="flex items-center gap-3">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          defaultValue={defaultVal}
          disabled={disabled}
          className="flex-1"
        />
        <span className="text-sm text-muted-foreground w-10 text-right">{defaultVal}</span>
      </div>
    </div>
  );
}
